import queries from '@apis/queries';
import useUser from '@hooks/auth/useUser';
import { useQuery } from '@tanstack/react-query';

function useFavoritePrepaidCards() {
  const { user } = useUser();
  const { data, status } = useQuery({
    ...queries.userPrepaidCard.favoriteList(user?.nickname || ''),
    enabled: !!user,
    retry: 1,
  });
  const prepaidCards = data?.cards;
  const isLoading = status === 'pending';
  const isBlank = !isLoading && (!prepaidCards || prepaidCards.length === 0);
  return {
    prepaidCards, isBlank, isLoading,
  };
}

export default useFavoritePrepaidCards;
